import {
  Box,
  Collapse,
  Container,
  Divider,
  Flex,
  Group,
  Stack,
  Title,
} from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { Form, useSubmit } from '@remix-run/react'
import { useState } from 'react'
import { TbChevronDown } from 'react-icons/tb'
import { LineButton } from './line-button'
import { LoginForm, loginFormSchema } from './login-form'

type RegisteredUserLoginFormProps = {
  eventId: string
  actionData?: {
    applicationError: string
  }
  redirectToPathOnSuccessfulLineLogin: string
}

export const RegisteredUserLoginForm = ({
  eventId,
  actionData,
  redirectToPathOnSuccessfulLineLogin,
}: RegisteredUserLoginFormProps) => {
  const submit = useSubmit()
  const [_, setIsLoading] = useState(false)
  const [isLoginCollapseOpened, { toggle: toggleLoginCollapse }] =
    useDisclosure(true)
  const [loginFormValidationErrors, setLoginFormValidationErrors] = useState<{
    [key: string]: string[]
  }>({})

  const isString = (value: unknown): value is string => {
    return typeof value === 'string'
  }

  const validateLoginForm = () => {
    const formData = new FormData(
      (document.querySelector('form#loginForm') as HTMLFormElement) ??
        undefined,
    )
    const emailField = formData.get('email') // type FormDataEntryValue = File | string;
    const passwordField = formData.get('password')

    const email = isString(emailField) ? emailField : null
    const password = isString(passwordField) ? passwordField : null

    const validationResult = loginFormSchema.safeParse({ email, password })

    if (!validationResult.success) {
      setLoginFormValidationErrors(validationResult.error.flatten().fieldErrors)
      return false
    }

    setLoginFormValidationErrors({})
    return true
  }

  const handleLoginFormSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    setIsLoading(true)
    const isValid = validateLoginForm()
    if (!isValid) return

    const form = event.currentTarget as HTMLFormElement
    submit(form, {
      method: 'post',
      action: `/events/register/${eventId}?form=login`,
    })
    setIsLoading(false)
  }

  return (
    <Box>
      <Divider my='lg' />
      <Box my='md' onClick={toggleLoginCollapse}>
        <Group justify='start' align='center'>
          <Title order={3}>会員登録済みの方はログイン</Title>
          <TbChevronDown />
        </Group>
      </Box>
      <Collapse in={isLoginCollapseOpened} transitionDuration={500}>
        <Container size='md'>
          <Stack my='md' gap={8}>
            <Form
              method='POST'
              action={`/events/register/${eventId}?form=login`}
              id='loginForm'
              onSubmit={handleLoginFormSubmit}
            >
              <Title order={2} fw='bold' my={'md'}>
                メールアドレスでログイン
              </Title>
              <LoginForm
                validationErrors={loginFormValidationErrors}
                actionData={{
                  applicationError: actionData?.applicationError,
                }}
              />
            </Form>

            <Stack my='md'>
              <Title order={2} fw='bold' my={'md'}>
                LINEでログイン
              </Title>
              <Flex justify='center' align='center' gap={0}>
                <LineButton
                  label='LINEでログイン'
                  link={redirectToPathOnSuccessfulLineLogin}
                  w={{ base: '100%', sm: '100%', md: '50%' }}
                />
              </Flex>
            </Stack>
          </Stack>
        </Container>
      </Collapse>
      <Divider my='lg' />
    </Box>
  )
}
